/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import UserSearch from '../search/UserSearch';
import Loader from '../loader';
import { Suggestion } from '../search/SearchComponent';

interface SearchModalProps {
  // Must be valid userId
  handleSubmit: ({ userId }: { userId: string }) => void;
  toggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isOpen: boolean;
  title?: string;
  surveyId?: string;
  ignoredIds: string[];
}

export const SurveyDelegationSearchModal = (props: SearchModalProps) => {

  const { isOpen, title = 'Add a user' } = props;
  const [isSaving, setIsSaving] = useState(false);
  const [selection, setSelection] = useState<Suggestion | undefined>();

  return (
    <Modal isOpen={isOpen} toggle={props.toggle} backdrop='static' className='user-search-modal'>
      <ModalHeader toggle={props.toggle}>{title}</ModalHeader>
      <ModalBody>
        <p>Please type in a known user or e-mail address.</p>
        <div className='row mt-3'>
          <div className='offset-2 col-8 searchbox-container'>
            {
              isSaving ?
                (
                  <Loader relative={true} />
                ) : (
                  <UserSearch
                    name={'stakeholder'}
                    placeholder={'Name'}
                    required={true}
                    ignoredIds={props.ignoredIds}
                    surveyId={props.surveyId}
                    inputClassName={'form-control w-100'}
                    handleValueChange={(_searchStr, currentSuggestion) => {
                      setSelection(currentSuggestion);
                    }} />
                )
            }
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={!selection || isSaving}
          onClick={() => {
            if (selection) {
              setIsSaving(true)
              props.handleSubmit({ userId: selection._id });
              setSelection(undefined);
              setIsSaving(false)
            }
          }}>
          Add User
        </Button>
      </ModalFooter>
    </Modal>
  )
}
